import React from "react";
import api from "../../../Api/apiAxios";
import { useNavigate, useParams } from "react-router-dom";
import { Alert, Button, Col, FloatingLabel, Row } from "react-bootstrap";
import Form from 'react-bootstrap/Form';
import Loading from "../../../Components/Loading";
import styles from "./ViewPersonalizacaoAcesso.module.css";
import { Container, Paper, Table, TableBody, TableContainer, TableHead, TableRow } from "@mui/material";
import { format } from "date-fns";
import { FormSectionBox } from "../../Pedidos/styles";
import { StyledTableCell } from "../../Pedidos/components/acesso/acessoIndex";

const ViewPersonalizacaoAcesso = () => {
    const { id } = useParams();

    const navigate = useNavigate();     

    const [loading, setLoading] = React.useState(false);
    const [registro, setRegistro] = React.useState({});
    const [dataValidade, setDataValidade] = React.useState('');
    const [dataPedido, setDataPedido] = React.useState('');
    const [dataLiberacao, setDataLiberacao] = React.useState('');
    const [dataCancelamentoContrato, setDataCancelamentoContrato] = React.useState('');
    const [negociacoes, setNegociacoes] = React.useState([]);
    const [contratoId, setContratoId] = React.useState(null);
    const [contrato, setContrato] = React.useState(null);
    const [observacoesPedido, setObservacoesPedido] = React.useState('* * * * * *');

    const getModalidadeConfig = (tipoInstalacao) => {
        const config = {
            0: {
            tipoComercializacao: 1,
            tipoServicoPedido: 1,
            tipoLicenciamento: 2,
            },
            1: {
            tipoComercializacao: 2,
            tipoServicoPedido: 2,
            },
            2: {
            tipoComercializacao: 2,
            tipoServicoPedido: 2,
            },
        };

        return config[tipoInstalacao];
    };

    React.useEffect(() => {
        (async () => {
            setLoading(true);

            try {   
                const tipo = "ID";
                const response = await api.get(`/LicencaAcesso/${tipo}/${id}`);  
                
                if (response.data.tipoComercializacao === null && response.data.tipoInstalacao !== undefined) {
                    const config = getModalidadeConfig(response.data.tipoInstalacao);
                    response.data = {
                        ...response.data,
                        ...config,
                    };
                }

                if   (response.data.dataValidade) {                    
                     var data = response.data.dataValidade.toString();
                     var ano = data.substr(0,4);
                     var mes = data.substr(5,2);
                     var dia = data.substr(8,2);                  
                     setDataValidade(dia + "/" + mes + "/" + ano);            
                }
                else (response.data.tipoComercializacao === 1) ? setDataValidade("Cópia Vitalicia!") : setDataValidade('* * * * * *');                        
                    
                let dataRegistroOriginal = null;
                if (response.data.dataRegistro !== null) {
                    dataRegistroOriginal = response.data.dataRegistro;
                    const dataRegistroString = response.data.dataRegistro.substring(8,10) + "/" +
                                               response.data.dataRegistro.substring(5,7)  + "/" +   
                                               response.data.dataRegistro.substring(0,4);
                    response.data.dataRegistro = dataRegistroString;
                }
                else response.data.dataRegistro = '* * * * * *';

                if  (response.data.pedidoId > 0) {
                    const resp2 = await api.get(`/BmaAcesso/${response.data.pedidoId}`); 
                    const data = resp2.data.dataPedido.substring(8,10) + "/" +
                                 resp2.data.dataPedido.substring(5,7)  + "/" +   
                                 resp2.data.dataPedido.substring(0,4);
                    setDataPedido(data);
                    setObservacoesPedido(resp2.data.observacao || '* * * * * *');

                    if (resp2.data.dataLiberacao !== null) {
                        const data2 = resp2.data.dataLiberacao.substring(8,10) + "/" +
                                      resp2.data.dataLiberacao.substring(5,7)  + "/" +   
                                      resp2.data.dataLiberacao.substring(0,4);
                        setDataLiberacao(data2);
                    }
                    else setDataLiberacao('* * * * * *');

                }
                else {
                    setDataPedido('* * * * * *');
                    setDataLiberacao('* * * * * *');
                    setObservacoesPedido('* * * * * *');
                }

                try {
                    const historicoResponse = await api.get(`/ContratoHistorico/por-ns/${response.data.numeroSerie}`);
                    if (historicoResponse.data && historicoResponse.data.length > 0) {

                        const dataReferencia = dataRegistroOriginal 
                            ? new Date(dataRegistroOriginal) 
                            : (response.data.dataValidade ? new Date(response.data.dataValidade) : new Date());
                        
                        const historicoNaData = historicoResponse.data
                            .filter(h => {
                                const dataAtualizacao = h.dataAtualizacao ? new Date(h.dataAtualizacao) : null;
                                return dataAtualizacao && dataAtualizacao <= dataReferencia;
                            })
                            .sort((a, b) => {
                                const dataA = a.dataAtualizacao ? new Date(a.dataAtualizacao) : new Date(0);
                                const dataB = b.dataAtualizacao ? new Date(b.dataAtualizacao) : new Date(0);
                                return dataB - dataA; 
                            })[0];
                        
                        if (historicoNaData) {
                            setContrato(historicoNaData);
                            setContratoId(historicoNaData.contratoId || historicoNaData.id);
                            
                            if (historicoNaData.dataCancelamento) {
                                const dataCancelamento = historicoNaData.dataCancelamento.substring(8,10) + "/" +
                                                         historicoNaData.dataCancelamento.substring(5,7)  + "/" +   
                                                         historicoNaData.dataCancelamento.substring(0,4);
                                setDataCancelamentoContrato(dataCancelamento);
                            } else {
                                setDataCancelamentoContrato('* * * * * *');
                            }
                        }
                    }
                } catch (contratoError) {
                    console.error('Erro ao buscar histórico do contrato:', contratoError);
                    // Fallback: buscar contrato atual
                    try {
                        const retorno = await api.get(`/Contrato/retornar-situacao-contrato?numeroSerie=${response.data.numeroSerie}`);
                        setContratoId(retorno.data.id);
                        setContrato(retorno.data);
                        if (retorno.data.dataCancelamento !== null) {
                            const dataCancelamento = retorno.data.dataCancelamento.substring(8,10) + "/" +
                                                     retorno.data.dataCancelamento.substring(5,7)  + "/" +   
                                                     retorno.data.dataCancelamento.substring(0,4);
                            setDataCancelamentoContrato(dataCancelamento);
                        } else {
                            setDataCancelamentoContrato('* * * * * *');
                        }
                    } catch (error) {
                        console.error('Erro ao buscar contrato:', error);
                    }
                }

                setRegistro(response.data);

            } catch (error) {
                alert(error);
            } finally {
                setLoading(false);
            }   
        }
        )();

    }, [id]);

    React.useEffect(() => {
        (async () => {
            if (!contratoId) return;
            try {
                const resp = await api.get(`/NegociacaoContrato/contrato?idContrato=${contratoId}&tipoSistema=Acesso`);
                if (resp.data && resp.data.length > 0) {
                    const negociacoesOrdenadas = resp.data.sort((a, b) => new Date(b.periodoInicial) - new Date(a.periodoInicial));
                    setNegociacoes(negociacoesOrdenadas);
                }
            } catch (error) {
                console.error('Erro ao buscar negociações:', error);
            }
        })();
    }, [contratoId]);                

    if  (loading) return <Loading />

    return (
        <section className={styles.form}>

            <Alert style={{background: 'ghostwhite', color: 'black'}}>
               <Alert.Heading style={{textAlign: 'center'}}>Licença BmaAcesso</Alert.Heading>        
            <br />  

            <Row className="g-2" style={{marginBottom: '1rem'}}>    
                <Col md='8'>
                     <FloatingLabel controlid="floatingInputGrid4" label="Revenda">
                        <Form.Control value={registro.distribuidor?.razaoSocial} disabled />
                      </FloatingLabel>      
                </Col>                
    
                <Col md='4'>
                     <FloatingLabel controlid="floatingInputGrid5" label="Número de Série">                               
                            <Form.Control value={registro.numeroSerie} disabled />                       
                    </FloatingLabel>      
                </Col>                
            </Row>

            <Row className="g-2" style={{marginBottom: '1rem'}}>    
                <Col md='8'>
                    <FloatingLabel controlid="floatingInputGrid2" label="Cliente">
                        <Form.Control value={registro.razaoSocial} disabled />             
                    </FloatingLabel>                  
                </Col>

                <Col md='4'>
                     <FloatingLabel controlid="floatingInputGrid4" label="CNPJ / CPF">
                        <Form.Control value={registro.numeroInscricao} disabled />
                      </FloatingLabel>      
                </Col>                
            </Row>

            <Row className="g-2" style={{marginBottom: '1rem'}}>
                <Col md='3'>
                    <FloatingLabel controlid="floatingInputGrid7" label="Vertical">
                        <Form.Select value={registro.tipoVertical} disabled>
                            <option value="" disabled></option>
                            <option value="1">Empresa</option>
                            <option value="2">Refeitório</option>
                            <option value="3">Academia</option>
                            <option value="4">Condomínio</option>
                            <option value="5">Hospital</option>
                            <option value="6">Escola</option>
                            <option value="7">Acesso Go</option>
                        </Form.Select>
                    </FloatingLabel>                    
                </Col>                

                <Col md='3'>
                    <FloatingLabel controlid="floatingInputGrid9" label="Banco De Dados">
                        <Form.Select value={registro.tipoBancoDados} disabled>
                            <option value="1">MySql</option>
                            <option value="2">SqlServer</option>
                            <option value="3">Oracle</option>
                        </Form.Select>
                    </FloatingLabel>                    
                </Col>
                <Col md='3'>
                    <FloatingLabel controlid="floatingInputGrid9" label="Equip.Adicional">
                        <Form.Control value={registro.equipamentoAdicional} disabled />
                    </FloatingLabel>                    
                </Col>
                <Col md='3'>
                    <FloatingLabel controlid="floatingInputGrid9" label="Server Adicional">
                        <Form.Control value={registro.serverAdicional} disabled />
                    </FloatingLabel>                    
                </Col>
            </Row>

            <Row className="g-2" style={{marginBottom: '1rem'}}>
                <Col md='3'>
                     <FloatingLabel controlid="floatingInputGrid6" label="Versão">
                            <Form.Control value={registro.versao} disabled />                        
                    </FloatingLabel>      
                </Col>                

                <Col md='3'>
                    <FloatingLabel controlid="floatingInputGrid11" label="Chave Registro">
                        <Form.Control value={registro.chaveRegistro} disabled />
                    </FloatingLabel>      
                </Col>

                <Col md='6'>
                    <FloatingLabel controlid="floatingInputGrid27" label="Valor Pedido (R$)">
                        <Form.Control value={registro.valorPedido} disabled />
                    </FloatingLabel>      
                </Col>

            </Row>                    

            <Row className="g-2" style={{marginBottom: '1rem'}}>
                <Col md='3'>
                     <FloatingLabel controlid="floatingInputGrid26" label="Data Pedido">
                            <Form.Control value={dataPedido} disabled />                        
                    </FloatingLabel>      
                </Col>                

                <Col md='3'>
                    <FloatingLabel controlid="floatingInputGrid43" label="Data Liberação">
                        <Form.Control value={dataLiberacao} disabled />
                    </FloatingLabel>      
                </Col>

                <Col md='3'>
                    <FloatingLabel controlid="floatingInputGrid11" label="Data Validade">
                        <Form.Control value={dataValidade} disabled />
                    </FloatingLabel>      
                </Col>

                <Col md='3'>
                    <FloatingLabel controlid="floatingInputGrid11" label="Data Registro">
                        <Form.Control value={registro.dataRegistro} disabled />
                    </FloatingLabel>      
                </Col>

            </Row>     

            <Row className="g-2" style={{ marginBottom: '1rem' }}>
              <Col md='12'>
                <FloatingLabel
                  controlId="floatingInputGridObs"
                  label="Observações do Pedido"
                  className="floatingTextareaFix"
                >
                  <Form.Control
                    as="textarea"
                    style={{
                      minHeight: '120px',
                      maxHeight: '170px',
                      overflowY: 'auto'
                    }}
                    value={observacoesPedido}
                    disabled
                  />
                </FloatingLabel>
              </Col>
            </Row>

            <Row className="g-2" style={{marginBottom: '1rem'}}>
                <Col md={registro.tipoComercializacao === 1 ? '4' : '6'}>
                    <FloatingLabel controlid="floatingInputGrid7" label="Tipo de Comercialização">
                        <Form.Select value={registro.tipoComercializacao} disabled>
                            <option value="1">Licenciado</option>
                            <option value="2">Locação</option>
                        </Form.Select>
                    </FloatingLabel>                    
                </Col>

                {registro.tipoComercializacao === 1 &&
                    <Col md='2'>
                        <FloatingLabel controlid="floatingInputGrid7" label="Tipo de Licenciamento">
                            <Form.Select value={registro.tipoLicenciamento} disabled>
                                <option value="1">Anual</option>
                                <option value="2">Prazo Indeterminado</option>
                            </Form.Select>
                        </FloatingLabel>                    
                    </Col>
                }

                <Col md='6'>
                    <FloatingLabel controlid="floatingInputGrid7" label="Tipo de Serviço">
                        <Form.Select value={registro.tipoServicoPedido} disabled>
                            <option value="1">On Premisse</option>
                            <option value="2">SaaS</option>
                        </Form.Select>
                    </FloatingLabel>                    
                </Col> 
            </Row>               

            <Row className="g-2" style={{marginBottom: '1rem'}}>
                <Col md='6'>
                    <FloatingLabel controlid="floatingInputGrid51" label="Contrato Cancelado em">
                        <Form.Control value={dataCancelamentoContrato} style={{color: 'tomato'}}  disabled />
                    </FloatingLabel>      
                </Col>

            </Row>                    

            <br /> 
            <hr />                    
            <Alert.Heading style={{textAlign: 'center'}}>Integrações & Módulos Adicionais</Alert.Heading>        
            <br /> 

            <Row className="g-2" style={{marginBottom: '1rem'}}>

                <Col md='3'>
                    <Form.Check 
                        type="switch"
                        id="integraWpe"
                        label="BmaPonto"                      
                        readOnly
                        checked={registro.wpe === 1}
                    />
                </Col>

                <Col md='3'>
                    <Form.Check 
                        type="switch"
                        id="integracaoFuncionarios"
                        label="Funcionários"                      
                        readOnly
                        checked={registro.integracaoFuncionarios === 1}                       
                    />
                </Col>

                <Col md='3'>
                    <Form.Check 
                        type="switch"
                        id="integracaoPacientes"
                        label="Pacientes"                      
                        readOnly
                        checked={registro.integracaoPacientes === 1}
                    />
                </Col>

                <Col md='3'>
                    <Form.Check 
                        type="switch"
                        id="integracaoAlunos"
                        label="Alunos"                      
                        readOnly
                        checked={registro.integracaoAlunos === 1}
                    />
                </Col>

            </Row>                    

            <Row className="g-2" style={{marginBottom: '1rem'}}>
                <Col md='3'>
                    <Form.Check 
                        type="switch"
                        id="contrato"
                        label="Contrato"                      
                        readOnly
                        checked={registro.temContrato === 1}
                    />
                </Col>

                <Col md='3'>
                    <Form.Check 
                        type="switch"
                        id="locacao"
                        label="Locação"                      
                        readOnly
                        checked={registro.locacao === 1}
                    />
                </Col>

                <Col md='3'>
                    <Form.Check 
                        type="switch"
                        id="agendaWeb"
                        label="Agenda Web"                      
                        readOnly
                        checked={registro.agendaWeb === 1}                        
                    />
                </Col>

                <Col md='3'>
                    <Form.Check 
                        type="switch"
                        id="lgpd"
                        label="Módulo LGPD"                      
                        readOnly
                        checked={registro.moduloLGPD === 1}
                    />
                </Col>

            </Row>      

            {contrato && contrato.id > 0 && (
              <>
              <br /> 
              <hr />                    
              <Alert.Heading style={{textAlign: 'center'}}>Informações do Contrato (na data da licença)</Alert.Heading>        
                <FormSectionBox>
                    <Container sx={{ my: 3 }}>
                        <TableContainer component={Paper} sx={{ overflow: 'visible' }}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell>ID</StyledTableCell>
                                        <StyledTableCell>Sistema</StyledTableCell>
                                        <StyledTableCell>Tipo de Contrato</StyledTableCell>
                                        <StyledTableCell>Status</StyledTableCell>
                                        <StyledTableCell>Data Ativação</StyledTableCell>
                                        <StyledTableCell>Data Atualização</StyledTableCell>
                                        <StyledTableCell>Valor (R$)</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        <StyledTableCell>{contrato.id}</StyledTableCell>
                                        <StyledTableCell>{contrato.sistema || '-'}</StyledTableCell>
                                        <StyledTableCell>
                                            {contrato.tipoContrato === 0 ? 'Manutenção' : 
                                             contrato.tipoContrato === 1 ? 'Locação' : 
                                             contrato.tipoContrato === 2 ? 'SaaS' : '-'}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            {contrato.statusContrato === 1 ? 'Ativo' : 
                                             contrato.statusContrato === 0 ? 'Cancelado' : 'Baixado'}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            {contrato.dataAtivacao ? format(new Date(contrato.dataAtivacao), 'dd/MM/yyyy') : '-'}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            {contrato.dataAtualizacao ? format(new Date(contrato.dataAtualizacao), 'dd/MM/yyyy') : '-'}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            {contrato.valor ? contrato.valor.toFixed(2) : '-'}
                                        </StyledTableCell>
                                    </TableRow>
                                    {contrato.dataCancelamento && (
                                        <TableRow>
                                            <StyledTableCell colSpan={7} style={{color: 'tomato', fontWeight: 'bold'}}>
                                                Contrato Cancelado em: {format(new Date(contrato.dataCancelamento), 'dd/MM/yyyy')}
                                                {contrato.motivoCancelamento && ` - Motivo: ${contrato.motivoCancelamento}`}
                                            </StyledTableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Container>
                </FormSectionBox>
              </>
            )}

            {negociacoes.length > 0 && (
              <>
              <br /> 
              <hr />                    
              <Alert.Heading style={{textAlign: 'center'}}>Negociações do Contrato</Alert.Heading>        
                <FormSectionBox>
                    <Container sx={{ my: 3 }}>
                        <TableContainer component={Paper} sx={{ overflow: 'visible' }}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell>Período Inicial</StyledTableCell>
                                        <StyledTableCell>Período Final</StyledTableCell>
                                        <StyledTableCell>Valor Negociado (R$)</StyledTableCell>
                                        <StyledTableCell>Motivo</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {negociacoes.length > 0 ? (
                                        negociacoes.map((row, index) => (
                                            <TableRow key={index}>
                                                <StyledTableCell>{format(new Date(row.periodoInicial), 'dd/MM/yyyy')}</StyledTableCell>
                                                <StyledTableCell>{format(new Date(row.periodoFinal), 'dd/MM/yyyy')}</StyledTableCell>
                                                <StyledTableCell>{row.valorNegociado.toFixed(2)}</StyledTableCell>
                                                <StyledTableCell>{row.descricaoMotivo}</StyledTableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <StyledTableCell colSpan={4} align="center">
                                                Nenhuma negociação encontrada
                                            </StyledTableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Container>
                </FormSectionBox>
              </>
            )}              

            </Alert>

            <div className={styles.areaBtn}>    
               <Button onClick={() => navigate(-1)} variant="outline-info" className={styles.btn}>Voltar</Button>
            </div>

            <style>
              {`
                .floatingTextareaFix label {
                  z-index: 2 !important;
                  background-color: #e9ecef !important;
                  color: rgba(33,37,41,1) !important;
                  opacity: 0.9 !important;
                  height: auto !important;
                  margin-top: 7px !important;
                }

                .floatingTextareaFix textarea {
                  padding-top: 3rem !important;
                }
              `}
              </style>    

        </section>
    )
}

export default ViewPersonalizacaoAcesso;
